<template>
    <div>
        <div>推广时间：{{ row.activityPromotionTime }}</div>
        <div>
				活动名称：<span>{{ row['activityName'] ? row['activityName'] : '-' }}</span></div
			>
        <div class="flex">团长: {{ row.institutionName }} <ID-tag class="ml-6 id-tag" :id="row.institutionId"></ID-tag> </div>
    </div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import IDTag from '@/components/ui/IDTag';
export default {
    mixins: [mixin],
    components:{
        IDTag
    },
    data(){
        return {

        }
    }
}
</script>
<style lang="less" scoped>
.id-tag{
   height: 20px !important;
   line-height: 22px !important;
}
</style>